class SupplementFactsModal extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.supplement-facts-modal__overlay');
    this.closeButton = this.querySelector('.supplement-facts-modal__close');
    this.drawer = this.querySelector('.supplement-facts-modal__drawer');
    this.trigger = null;
    
    this.bindEvents();
  }

  bindEvents() {
    // Close on X button click
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    }

    // Close on overlay click (clicking outside)
    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });

    // Prevent drawer content clicks from closing modal
    if (this.drawer) {
      this.drawer.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }

  open(trigger = null) {
    this.trigger = trigger;
    this.classList.add('supplement-facts-modal--active');
    
    // Lock body scroll with
    document.body.style.overflow = 'hidden';
    document.body.classList.add('supplement-facts-modal-open');
    
    // Focus management for accessibility
    this.trapFocus();
  }

  close() {
    this.classList.remove('supplement-facts-modal--active');
    
    // Unlock body scroll
    document.body.style.overflow = '';
    document.body.classList.remove('supplement-facts-modal-open');
    
    // Return focus to trigger element
    if (this.trigger) {
      this.trigger.focus();
      this.trigger = null;
    }
  }

  isOpen() {
    return this.classList.contains('supplement-facts-modal--active');
  }

  trapFocus() {
    const focusableElements = this.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusableElements.length === 0) return;
    
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    
    // Focus first element (close button)
    setTimeout(() => {
      this.closeButton ? this.closeButton.focus() : firstElement.focus();
    }, 100);
    
    // Handle tab key navigation
    const handleTabKey = (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }
    };
    
    this.addEventListener('keydown', handleTabKey);
  }
}

// Modal trigger functionality
class SupplementFactsTrigger extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.modalId = this.getAttribute('data-modal');
    
    if (this.button && this.modalId) {
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.openModal();
      });
    }
  }

  openModal() {
    const modal = document.getElementById(this.modalId);
    if (modal && typeof modal.open === 'function') {
      modal.open(this.button);
    } else {
      console.error('Modal not found or open method not available:', this.modalId);
    }
  }
}

// Define custom elements
customElements.define('supplement-facts-modal', SupplementFactsModal);
customElements.define('supplement-facts-trigger', SupplementFactsTrigger);

// Debug logging
console.log('Supplement Facts Modal JS loaded'); 